import { Bootstrap as params } from "./_params.js"
import * as BootstrapModel from "./model.js"

export const Bootstrap = {
  params,
  domain: params.domain,
  actions: BootstrapModel.actions,
  effects: BootstrapModel.effects,
}
